const $ = jQuery;
let queryOrder = 'orderby=title&order=asc';

/**
 * @param rowId
 * @param message
 */
function noResultsFound( rowId, message ) {
    $( rowId ).html( '' +
        '<div class="col-xs-12 col-sm-6 col-md-3">\n' +
        '            <div class="item product-item">\n' +
        '                <p>'+message+'</p>\n' +
        '            </div>\n' +
        '        </div>' );
}

/**
 *
 * @param postType
 * @param query
 */
function getPostsByType( postType, query ) {
    let loaderGifSrc = '/wp-admin/images/spinner-2x.gif';
    let $productRow = $( '#productRow' );
    let queryVars = '';

        $productRow.html('<img src="'+loaderGifSrc+'" style="margin: 1em;" alt="wait for it"/>' );

    if ( query === '' ) {
        queryVars = $( document ).find("main").data( 'productqueryvars' );
        if ( queryVars ) {
            query = queryVars;
        }
    }

    if ( postType === 'products' && query === '' && queryVars === '' ||
         postType === 'products' && query === '' && queryVars === undefined ) {
        query = query + '?' + queryOrder;
    } else if ( postType === 'products' ) {
        query = query + '&' + queryOrder;
    }

    let rest_endpoint   = '/wp-json/wp/v2/' + postType;
    let endpointAndQuery = rest_endpoint + query;
    $.get(
        endpointAndQuery,
        '',
        function( results ) {
            if ( postType === 'products' ) {
                loadProducts( results )
                if ( results.length === 0 ){
                    noResultsFound( '#productRow', 'No Products found' );
                }
            }
            if ( postType === 'projects' ) {
                loadProjects( results )
                if ( results.length === 0 ){
                    noResultsFound( '#projectRow', 'No Projects found' );
                }
            }
            if ( postType === 'posts' ) {
                loadNews( results )
                if ( results.length === 0 ){
                    noResultsFound( '#newsRow', 'No Posts found' );
                }
            }

        }
    );
}